import PropTypes from 'prop-types';
import React from 'react';

export const SINGLE_REVIEW_PROPTYPES = {
    user: PropTypes.shape({
        username: PropTypes.string,
        image: PropTypes.shape({
            src: PropTypes.string,
            alt: PropTypes.string,
        }),
    }),
    date: PropTypes.string,
    rating: PropTypes.string,
    reviewDetails: PropTypes.arrayOf(
        PropTypes.shape({
            headline: PropTypes.string.isRequired,
            response: PropTypes.string,
            barChar: PropTypes.number,
            extraInfo: PropTypes.string,
            comment: PropTypes.string,
        })
    ),
    googleSeo: PropTypes.string,
};
